import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tagNameValid',
  standalone: true,
})
export class TagNameValidPipe implements PipeTransform {
  public transform = (value: string): boolean => !!(value && value.length > 0 && value.length <= 40);
}
